import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { formatVisualOptions } from 'utils/form/formatOptions';
import {
  useCreatePrintingPage as useCreatePrintingPageMutation,
  usePrintOnDemandProducts,
} from 'hooks/queries/printOndemandeProducts/usePrintOnDemandeProduct';
import * as yup from 'yup';

type Props = {
  printingOrder: string;
  closeModal: () => void;
};

const schema = () =>
  yup.object({
    printingPageType: yup.string().required(),
    name: yup.string(),
  });

type FormValues = yup.InferType<ReturnType<typeof schema>>;

const REFERENCE_TO_ICON = {
  NORMAL: 'fa-solid fa-cards-blank',
  FOIL: 'fa-solid fa-sparkles',
};

const useCreatePrintingPage = ({ printingOrder, closeModal }: Props) => {
  const { data } = usePrintOnDemandProducts();
  const createPage = useCreatePrintingPageMutation({ orderId: printingOrder });

  const formMethods = useForm<FormValues>({
    mode: 'onSubmit',
    resolver: yupResolver(schema()),
  });

  const options = formatVisualOptions(data?.['hydra:member'], {
    valueField: '@id',
    labelField: 'name',
    getIconField: (entity) => REFERENCE_TO_ICON[entity.type as keyof typeof REFERENCE_TO_ICON],
  });

  const { handleSubmit } = formMethods;
  const onSubmit = async ({ printingPageType, name }: FormValues) => {
    await createPage.mutateAsync({
      printOnDemandProduct: printingPageType,
      name,
    });
    closeModal();
  };

  return { formMethods, options, handleSubmit: handleSubmit(onSubmit) };
};

export default useCreatePrintingPage;
